module.exports = __webpack_public_path__ + "img/avatar3.fb32341a.png";